module.exports = __webpack_public_path__ + "img/top-3.0a5c1b1f.png";